angular.module('inspinia').factory('authoritiesService', function () {
  let state = {
    authorities: [],
  };

  // Getters

  /**
   * @returns authorities
   */
  const getAuthorities = () => {
    return state.authorities;
  };

  /**
   * @returns video streaming authority
   */
  const getVideoStreamingUse = () => {
    return (state.authorities && state.authorities['video_streaming_use'] === '1') || false;
  };

  /**
   * @returns sales authority
   */
  const getSalesUse = () => {
    return (state.authorities && state.authorities['sales_use'] === '1') || false;
  };

  // Mutations

  /**
   * @param {*} authorities
   */
  const setAuthorities = (authorities) => {
    state.authorities = authorities;
  };

  /**
   * 新しい権限を追加
   * @param {object} authority
   */
  const addAuthority = (authority) => {
    Object.assign(state.authorities, authority);
  };

  // Actions

  return {
    ...state,
    getAuthorities,
    getVideoStreamingUse,
    getSalesUse,
    setAuthorities,
    addAuthority,
  };
});
